export const isWorkspaceId = (value: unknown): value is string =>
  typeof value === "string" &&
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);

export const getIdAfterSegment = (
  pathname: string,
  segmentName: string
): string => {
  const segments = pathname.split("/").filter(Boolean);
  const index = segments.indexOf(segmentName);
  return index === -1 ? "" : segments[index + 1] ?? "";
};

export const getWorkspaceId = (
  pathname: string,
  search: string
): string | undefined => {
  const pathWorkspaceId = getIdAfterSegment(pathname, "workspace");
  if (pathWorkspaceId) {
    return isWorkspaceId(pathWorkspaceId) ? pathWorkspaceId : undefined;
  }
  const params = new URLSearchParams(search);
  const values = params.getAll("workspaceId");
  const queryWorkspaceId = values.length === 1 ? values[0] : undefined;
  const value = params.has("workspaceId")
    ? queryWorkspaceId
    : getIdAfterSegment(pathname, "workspace");
  return isWorkspaceId(value) ? value : undefined;
};

export const withWorkspaceId = (
  path: string,
  workspaceId = getWorkspaceId(
    globalThis.location.pathname,
    globalThis.location.search
  )
): string => {
  if (!isWorkspaceId(workspaceId)) return path;
  const url = new URL(path, globalThis.location.origin);
  const segments = url.pathname.split("/").filter(Boolean);
  if (segments[0] === "app") {
    const orgIndex = segments[1] === "workspace" ? 3 : 1;
    if (segments[orgIndex] === "organization") {
      url.pathname = [
        "",
        "app",
        "workspace",
        workspaceId,
        "organization",
        ...segments.slice(orgIndex + 1),
      ].join("/");
    } else if (segments[1] !== "workspace") {
      url.pathname = `/app/workspace/${workspaceId}/${segments
        .slice(1)
        .join("/")}`;
    }
  }
  url.searchParams.delete("workspaceId");
  return `${url.pathname}${url.search}${url.hash}`;
};
